import { render } from "./AdminSelectLang.vue?vue&type=template&id=b627a324&scoped=true"
import script from "./AdminSelectLang.vue?vue&type=script&lang=js"
export * from "./AdminSelectLang.vue?vue&type=script&lang=js"

import "./AdminSelectLang.vue?vue&type=style&index=0&id=b627a324&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b627a324"]])

export default __exports__